import { useState } from 'react';
import { mockFaq } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            关于虫虫漫画的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="space-y-3">
            {mockFaq.map((faq, i) => (
              <div
                key={i}
                className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
                  onClick={() => toggle(i)}
                >
                  <h3 className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</h3>
                  <div className={`w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-500 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}>
                    <i className="ri-arrow-down-s-line"></i>
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}